var map = {
	"./d2-admin-text.svg": "ae5c",
	"./d2-admin.svg": "bb12",
	"./file-excel.svg": "66ee",
	"./file-pdf.svg": "0b64",
	"./file-word.svg": "0377",
	"./file-zip.svg": "dcaf",
	"./oil.svg": "ca8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec399";